import React, { Component, createRef } from 'react';

import InfiniteScrollPagination from 'components/infinityScrollPagination/infiniteScrollPagination';
import { SearchFilter } from 'components/input';
import { translate } from 'components/translate';
import { UserInfo } from 'components/user';
import PropTypes from 'prop-types';

import '../BroadcastDetail.scss';

@translate()
export default class BroadcastDetailUsers extends Component {
  static propTypes = {
    fetchUsers: PropTypes.func.isRequired,
    descriptionLabel: PropTypes.string,
    t: PropTypes.func
  };

  state = {
    searchText: '',
    users: []
  };

  usersRef = createRef();

  fetchAllUsers = async (searchText) => {
    const { fetchUsers } = this.props;
    const response = await fetchUsers(searchText, 0);
    const users = response?.content || [];

    this.setState(
      {
        users,
        searchText
      },
      () => {
        if (this.usersRef.current) {
          this.usersRef.current.scrollTop = 0;
        }
      }
    );
  };

  async componentDidMount() {
    const { searchText } = this.state;

    this.fetchAllUsers(searchText);
  }

  handlePageChange = async (page) => {
    const { fetchUsers } = this.props;
    const { searchText } = this.state;

    const response = await fetchUsers(searchText, page + 1);

    this.setState((prevState) => ({
      users: prevState.users.concat(response.content)
    }));
  };

  render() {
    const { descriptionLabel, t } = this.props;
    const { users, searchText } = this.state;

    return (
      <div className="broadcast__modal">
        <h1>{t('broadcast.modal.users.users_list')}</h1>
        <p>{t(`broadcast.modal.users.${descriptionLabel}`)}</p>
        <p className="message__content--active">
          {t('broadcast.modal.users.users_search')}
        </p>
        <SearchFilter>
          <SearchFilter.SearchInput
            autoComplete="off"
            classIcon="users__manager__search__filter__icon"
            icon="search"
            maxLength="120"
            onChange={this.fetchAllUsers}
            placeholder="users_manager.users_list.filter.input"
          />
        </SearchFilter>
        <p className="message__content--active">
          {t('general.student_plural')}
        </p>
        <section className="broadcast__modal__panel" ref={this.usersRef}>
          <InfiniteScrollPagination
            onPageChange={this.handlePageChange}
            search={searchText}
          >
            {users?.map((user) => (
              <UserInfo
                key={user.userId}
                className="broadcast__modal__panel__item"
                name={user.name}
                email={user.email}
                pictureFileKey={user.pictureFileKey}
                pictureThumbId={user.pictureThumbId}
              />
            ))}
          </InfiniteScrollPagination>
        </section>
      </div>
    );
  }
}
